import { makeStyles } from 'tss-react/mui'

const getBgImage = ({ isBackground, metaData, theme }) => {
	const styles =
		isBackground && metaData?.image
			? {
					backgroundImage: `url("${metaData.imageThumb}")`,
					...metaData.backgroundMediaFrom(theme),
			  }
			: {
					backgroundImage: null,
			  }

	return {
		backgroundSize: 'cover',
		backgroundRepeat: 'no-repeat',
		backgroundPosition: 'center',
		...styles,
	}
}

const useStyles = makeStyles()((theme, { isBackground, metaData }) => ({
	image: {
		height: 'auto',
		width: '100%',
		maxHeight: '100%',
		display: 'block',
	},
	bgImage: getBgImage({ isBackground, metaData, theme }),
}))

export default useStyles
